import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import generalActions from 'redux/actions/generalActions'
import quizActions from 'redux/actions/quizActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import containerSelector from 'redux/selectors/quiz/quiz_timer_modal_selector'

import TimerModal from 'views/modals/timer_modal'

class QuizTimerModalContainer extends PureComponent {

	constructor() {
		super()
		this.closeModalHandler = this.closeModalHandler.bind(this)
	}

	closeModalHandler() {
		this.props.actions.closeModal(this.props.modalName)
	}

	render() {
		return (
			<TimerModal
				max={5999}
				min={0}
				step={15}
				value={this.props.value}
				saveHandler={this.props.actions.save}
				cancelHandler={this.props.actions.cancel}
				closeModalHandler={this.closeModalHandler}
			/>
		)
	}

}

function mapStateToProps(state) {
	return containerSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
		save: quizActions.saveTimer,
		cancel: quizActions.cancelTimer,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(QuizTimerModalContainer)
